import restoreCart from "../../main-product/estimated-delivery/restoreCart";
import { CART_NOT_RESTORED_KEY, ORIGINAL_CART_KEY } from "../../main-product/estimated-delivery/estimatedDeliveryStorageKeys";

try {
  const cartNotRestored = window.localStorage.getItem(CART_NOT_RESTORED_KEY);

  if (cartNotRestored) {
    const cart = JSON.parse(window.localStorage.getItem(ORIGINAL_CART_KEY));

    restoreCart(cart).then(() => {
      window.localStorage.removeItem(CART_NOT_RESTORED_KEY);
      const data = {
        updates: {},
      };

      data.sections = "main-cart,header";

      window.updateCart(data.updates, data.sections, {}, { openCart: false });
    });
  }
} catch (error) {
  console.warn(error);
}
